<template>
  <div>
    <h2>Constancia de No Adeudo Armeria</h2>
    <label>
      Nombre del personal:
      <input v-model="nombre" placeholder="Nombre completo" />
    </label>
    <label>
      Fecha:
      <input v-model="fecha" type="date" />
    </label>
    <button @click="generarWord">Generar Word</button>
  </div>
</template>
<script>
import { Packer } from 'docx'
import ConstanciaNoAdeudoArmeria from '@/utils/doc-generator/armeria/ConstanciaNoAdeudo'

export default {
  data() {
    return {
      nombre: '',
      fecha: '',
    }
  },
  methods: {
    async generarWord() {
      const newDoc = await new ConstanciaNoAdeudoArmeria().generate()
      const blob = await Packer.toBlob(newDoc)
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'ConstanciaNoAdeudoArmeria.docx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
  },
}
</script>
